import type { ReactNode } from 'react'
import { BrandMark } from '@/shell/components/brand-mark'
import { Toaster } from '@/shell/components/toast'

/** Static-feeling auth frame (PRD-018 §6.4): centered card, wordmark, one task per screen. */
export function AuthLayout({ title, lede, children, footer }: { title: string, lede?: ReactNode, children: ReactNode, footer?: ReactNode }) {
  return (
    <main className="min-h-screen bg-secondary flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex items-center gap-3">
          <BrandMark className="size-9 shrink-0" />
          <span className="text-lg font-semibold text-primary">Gallop</span>
        </div>
        <div className="rounded-xl bg-primary p-6 shadow-sm ring-1 ring-secondary">
          <h1 className="text-xl font-semibold text-primary">{title}</h1>
          {lede ? <p className="mt-1 text-sm text-tertiary">{lede}</p> : null}
          <div className="mt-6">{children}</div>
        </div>
        {footer ? <div className="mt-4 text-center text-sm text-tertiary">{footer}</div> : null}
      </div>
      <Toaster />
    </main>
  )
}

export function FormError({ message }: { message: string | null }) {
  if (!message)
    return null
  return <p role="alert" className="mt-3 text-sm text-error-primary">{message}</p>
}
